import { ChangeDetectorRef, Component, OnChanges, OnInit, ViewChild } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { ITreeOptions, KEYS, TREE_ACTIONS, TreeComponent } from 'angular-tree-component';
import * as _ from 'lodash';

// config

// Core
import { UiMessageSnackService } from '../../../core/components/message-snack/service/message-snack.service';
import { IBoolResult } from '../../../core/interfaces/bool-result';
import { ErrorMessage } from '../../../core/model/error-message';

// Redux
import { NgRedux } from '@angular-redux/store';
import { IAppState } from '../../../core/store/store';

// Own feature
import { NavElementsContainer } from '../../model/nav-elements-container';
import { NavigationService } from '../../service/navigation.service';
import { navigationStore2stEdgeDefinitionConfig } from '../../store/actions';
import { NavGraph2MdlgComponent } from '../nav-graph2-mdlg/nav-graph2-mdlg';

// import navElementContainer
import { appConfig } from '../../../config/app-config';
import { ConfirmDialogsService } from '../../../core/components/confirm-dialog/service/confirm-dialog.service';
import { gNavElementContainer } from '../../compc/nav-cont/nav-cont.component';
import { INavElementsEdge } from '../../model/nav-elements-edgegroup';
import { INavElementsNode } from '../../model/nav-elements-nodegroup';
import { NavElementsRoot } from '../../model/nav-elements-root';
import { INavGraph2SelResult } from '../../model/nav-graph2-sel-result.interface';
import { ITreeNode, NavListNodeType_edgeLevel1 } from '../../model/nav.types';
import { UpdatableContent } from '../../model/reload-content.abstract';
import { LoadingphaseService } from '../../service/loadingphase.service';
import { TreeDataServiceService } from '../../service/tree-data-service.service';
import { INavConfig } from '../../store/store';

interface ExpandableTreeThing {
   id: number;
   isExpanded: boolean;
   children: ExpandableTreeThing[];
}

@Component({
   selector: 'app-nav-tree',
   templateUrl: './nav-tree.html',
   styleUrls: ['./nav-tree.scss']
})
export class NavTreeComponent implements OnInit, OnChanges, UpdatableContent {

   private readonly = true;
   // titel/subtitel for search graph mdlg
   private _titleSearchGraph = 'Beziehung für:';
   private _subtitleSearchGraph = 'Art der neuen Beziehung:';
   public titelSearchGraph = '';
   public subtitleSearchGraph = '';

   // loading data
   public set _loadingPhase(value: boolean) {
      this._loadingphaseService.setContentBlockState(value);
      this._loadingphaseService.setLoadingphase(value, 'nav_graph');
   }

   // config
   private _config: INavConfig = null;

   // input object für list control
   public nodes: ITreeNode[] = [];

   options: ITreeOptions = {
      // displayField: 'nodeName',
      // isExpandedField: 'expanded',
      // idField: 'uuid',
      // hasChildrenField: 'nodes',
      actionMapping: {
         mouse: {
            dblClick: (tree, node, $event) => {
               if (node.hasChildren) { TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event); }
            },
            contextMenu: (tree, node, $event) => {
               $event.preventDefault();
               // call property menu handler
               this.propertyMenu(tree, node, $event);
            }
         },
         keys: {
            [KEYS.ENTER]: (tree, node, $event) => {
               node.expandeAll();
            }
         },
      },
      nodeHeight: 23,
      allowDrag: (node) => {
         return false;
      },
      allowDrop: (node) => {
         return false;
      },
      useVirtualScroll: true,
      animateExpand: true,
      // scrollOnActivate: true,
      animateSpeed: 30,
      animateAcceleration: 1.2
   };

   // graph container
   private navElementContainer: NavElementsContainer = null;

   // children
   @ViewChild(TreeComponent) public treeComponent: TreeComponent = null;
   @ViewChild('navSearchMdlg') public readonly navSearchMdlg: NavGraph2MdlgComponent = null;

   constructor(
      private _navigationService: NavigationService,
      private _messageSnackService: UiMessageSnackService,
      private _store: NgRedux<IAppState>,
      private _confirmDialogService: ConfirmDialogsService,
      private _loadingphaseService: LoadingphaseService,
      private _treeData: TreeDataServiceService,
      private cdr: ChangeDetectorRef,
   ) {
      // import navElementContainer
      this.navElementContainer = gNavElementContainer;
   }

   ngOnInit() {
      // sanity
      const config: INavConfig = this._store.getState().navigationState.config;
      if (!config.hasOwnProperty('dictionary')) {
         console.warn('Dictionary in config nicht vorhanden');
         return;
      }
      if (!config.hasOwnProperty('search') || !config.search.hasOwnProperty('edges')) {
         console.warn('Search oder Edges in Config nicht vorhanden');
         return;
      }

      // keep config
      this._config = config;
   }

   nodeActivated(event: { node: ITreeNode }) {
      this.onSelectNode(event, event.node);
   }

   private insertStyleConfig(treeNodes: ITreeNode[], config: INavConfig) {
      for (const root of treeNodes) {
         const group = root.modeGroup;
         root.style = this.readStyleFromConfig(group, config);
         const edges = root.children;
         for (const edge of edges) {
            const edgeGroup = edge.edgeGroup;
            edge.style = this.readStyleFromConfig(edgeGroup, config);
            const nodes = edge.children;
            for (const node of nodes) {
               const id = node._id;
               const [, type] = new RegExp(/^(.*)\/.*/i).exec(id);
               if (type) {
                  node.style = this.readStyleFromConfig(type, config);
               }
            }
         }
      }
   }

   private readStyleFromConfig(name: string, config: INavConfig) {
      const parsedConfig = {};
      const flatConfig = config.appearance.list[name];
      if (flatConfig) {
         for (const confProp of Object.getOwnPropertyNames(flatConfig)) {
            const [, type, prop] = new RegExp(/(.*):(.*)/i).exec(confProp) || new Array();
            if (type && prop) {
               if (!parsedConfig[type]) {
                  parsedConfig[type] = {};
               }
               const typeConf = parsedConfig[type];
               typeConf[prop] = flatConfig[confProp];
            }
         }
      }
      return parsedConfig;
   }

   ngOnChanges() {
   }

   public reloadContent(root?: NavElementsRoot) {
      const rootId = root ? root.rootObj.id : this.navElementContainer.getVirtualRootId();
      if (!rootId) {
         return;
      }

      // setup tree
      this.treeComponent.treeModel.setState({});
      this.nodes = [];
      this.treeComponent.treeModel.update();
      this._treeData.InitializeForNode(this._config, rootId).then((nodes) => {
         if (nodes.length) {
            this.nodes = nodes;
            this.insertStyleConfig(this.nodes, this._config);
            this.treeComponent.treeModel.update();
            setTimeout(() => {
               this.expandInitial(this.nodes[0]);
               this.treeComponent.treeModel.update();
               this.treeComponent.sizeChanged();
            });
         }
      });
   }

   private findNode(id: string): ITreeNode[] {
      const queue = [...this.nodes];

      const result = [];

      while(queue.length) {
         const node = queue.shift();
         
         for(const edge of node.children) {
            queue.push(...edge.children);
         }
         
         if(node._id == id) {
            result.push(node);
         }
      }

      return result;
   }

   public updateNode(id: string, name: string) {
      this.findNode(id).forEach((n) => n.bezeichnung = name);
   }


   private expandInitial(node: ExpandableTreeThing) {
      if (node.isExpanded) {
         this.treeComponent.treeModel.getNodeById(node.id).expand();
      }
      if (node.children) {
         for (const child of node.children) {
            this.expandInitial(child);
         }
      }
   }

   // ---------------------------------------------------------------------------------------------
   // -- Event Handler
   // ---------------------------------------------------------------------------------------------
   public propertyMenu(tree, node, event: any) {
      console.log('Rechte Mouse');
   }

   public nodeAction(event: any) {
      console.log('Action1:', event);
   }

   public removeEdge(node) {
      this.removeEdgeLevel1(node.data);
   }

   public addEdge(event, node) {
      // sanity I
      if (!this.navSearchMdlg) {
         console.warn('Missing navigation modal dialog object');
         return;
      }

      // sanity II
      if (!node.data.type) {
         console.warn('Unexpected data type; expecting node.data.type');
         return;
      }

      // edge level 1
      if (node.data.type === NavListNodeType_edgeLevel1) {
         this.prepareAddEdgeLevel1(event, node);
         return;
      }

      // add "+" nur in level1 zulässig
   }

   public onSelectNode(event, node) {

      // sanity
      if (!node.data._id) {
         console.warn('Keine ID für Node');
         return;
      }

      this._loadingPhase = true;

      // -->>ASY
      this._navigationService.loadElements1stDetail(
         node.data._id
      )
         .then((boolResultASY: IBoolResult) => {
            this._loadingPhase = false;

            // result available
            if (boolResultASY.result) {
               return;
            }

            // no data
            this._messageSnackService.showSnackWarning(boolResultASY.message.message, 'NavElemGraphViewComponent');
         })
         .catch((err: ErrorMessage) => {
            this._loadingPhase = false;
            this._messageSnackService.showSnackError(err.message, 'NavElemGraphViewComponent');
         });
   }

   private searchForNode(nodes: any[], nodeToSearch: any): any | null {
      // check
      if (!nodes) { return null; }

      for (let i = 0; i < nodes.length; i++) {
         if (nodes[i].id === nodeToSearch.data.id) {
            return nodes[i];
         }
         // recursive
         if (nodes[i].children) {
            return this.searchForNode(nodes[i].children, nodeToSearch);
         }
      }
      return null;
   }

   // ---------------------------------------------------------------------------------------------
   // -- Event handler - Tree
   // ---------------------------------------------------------------------------------------------

   public onNavSearchCancel() {

   }

   public onNavSearchSubmit(graph2SelResult: INavGraph2SelResult, createDefaults?: boolean, createComponentDefaults?: boolean, createFGConnection?: boolean) {
      // sanity I
      const rootNode: INavElementsNode = this.navElementContainer.getVirtualRoot().rootObj;
      if (!rootNode) {
         console.warn('Root Node nicht vorhanden');
         return;
      }

      this._loadingPhase = true;

      // -->>ASYNC
      this._navigationService.addEdge(
         graph2SelResult,
         createDefaults,
         createComponentDefaults,
         createFGConnection,
      )
         .then((data: { document: INavElementsEdge, edges?: INavElementsEdge[], edgeCollection?: string }) => {

            // result available
            if (data) {

               // -->>ASYNC2 - lade node
               this._navigationService.loadNode(
                  graph2SelResult.node2Id
               )
                  .then((node: INavElementsNode) => {

                     // add node locally
                     this.navElementContainer.addNode(node);

                     // add edge locally
                     this.navElementContainer.addEdge(data.document);

                     for (const edge of data.edges || []) {
                        this.navElementContainer.addEdge(edge);
                     }

                     // reaload
                     this.reloadContent();

                     this._loadingPhase = false;

                     // success
                     this._messageSnackService.showSnackSuccess('Beziehung hergestellt', 'NavElemListViewComponent');



                     // ok
                     return;

                  })
                  .catch((err: ErrorMessage) => {
                     this._loadingPhase = false;
                     this._messageSnackService.showSnackError(err.message, 'NavElemListViewComponent');
                  });

               return;
            }

            this._loadingPhase = false;

            // no data
            this._messageSnackService.showSnackWarning('Keine Daten vom Backend erhalten', 'NavElemListViewComponent');
         })
         .catch((err: ErrorMessage) => {
            this._loadingPhase = false;
            if (err.code === 'missingDefaults') {
               this._confirmDialogService.openHelpMessage('Standart-Schaltungen', err.uiMessage, appConfig.app.showCreateDefaultsDialog).subscribe(
                  (res) => {
                     this.onNavSearchSubmit(graph2SelResult, res);
                  }
               );
            } else if (err.code === 'missingComponentDefaults') {
               this._confirmDialogService.openHelpMessage('Standart-Schaltungen', err.uiMessage, appConfig.app.showCreateDefaultsDialog).subscribe(
                  (res) => {
                     this.onNavSearchSubmit(graph2SelResult, undefined, res);
                  }
               );
            } else if (err.code === 'missingFGConnection') {
               this._confirmDialogService.openHelpMessage('Manuell ausgelöste Funktionsgruppe', err.uiMessage, true).subscribe(
                  (res) => {
                     this.onNavSearchSubmit(graph2SelResult, undefined, undefined, res);
                  }
               );
            } else {
               this._messageSnackService.logMessage('ERROR', {
                  consoleMessage: err.message,
                  duration: 3000,
                  module: 'NavElemListViewComponent',
                  uiMessage: err.uiMessage || err.message,
               });
            }
         });
   }

   public onNavSearchError($event) {

   }

   public onSchalterChanged(event: MatSelectChange, nodeData) {
      const edgeID = nodeData.refEdgeId;

      // Fall A: -1 => edge löschen
      if (event.value === '-1' && edgeID) {
         this.removeEdgeSchaltet(edgeID);
         nodeData.refEdgeId = null;

         // Fall B: 0,1,... => edge erzeugen
      } else if (event.value !== '-1' && !edgeID) {
         this.addEdgeSchaltet(event.value, nodeData._id, nodeData.edgeGroup).then((id) => {
            nodeData.refEdgeId = id;
         });

         // Fall C: Steuerzustand ändert => edge update
      } else {
         this.updateEdgeSchaltet(event.value, edgeID, nodeData.edgeGroup);
      }
   }

   // ---------------------------------------------------------------------------------------------
   // -- private function
   // ---------------------------------------------------------------------------------------------
   private removeEdgeLevel1(node: ITreeNode) {
      // ermittle zu löschende Edge
      if (!node.refEdgeId) {
         console.warn('Edge in Container nicht vorhanden');
         return;
      }

      const __edge = this._treeData.getEdgeById(node.refEdgeId);

      // bezeichnung für confirm dialog
      const n = node.nodeAbbr + ' ' + node.bezeichnung;

      // Anlage mit Komponenten mit Aktion
      const [edge] = node.refEdgeId.split('/');
      let removeSchaltet = false;
      if (edge === 'Steuert') {
         const [collection] = node._id.split('/');
         switch (collection) {
            case 'Steuerung':
            case 'Funktionsgruppe':
            case 'AnlageEntrauchungsanlage':
            case 'AnlageRltAnlage':
            case 'AnlageFoerderanlage':
               removeSchaltet = true;
               break;
         }
      }

      this._loadingPhase = true;

      // confirm dialog
      this._confirmDialogService
         .open(
            'Aktion Bestätigen',                                     // titel
            (removeSchaltet ?
               `Beim Löschen dieser Steuert-Beziehung zum Element ${n} werden auch alle existierenden Schaltet-Beziehungen 
                  zu Komponenten dieses Elements entfernt.`
               : `Wollen Sie die Beziehung zu Element: ${n} löschen?`),    // text
            true,             // Zeige Cancel Button
            'ABBRECHEN',      // Text: Cancel Button
            'LÖSCHEN'         // Text: Ok Button
         )
         .subscribe(async (res: boolean) => {        // result -> true (OK), false (Abbrechen)

            // true: löschen wurde bestätigt
            if (res) {

               if (removeSchaltet) {
                  const schaltet = this._treeData.hasSchaltung(__edge._to, __edge._from);
                  if (schaltet && schaltet.length) {
                     const response = await Promise.all(schaltet.map(schalt => this._navigationService.removeEdge(schalt)))
                        .then((array) => {
                           if (array.some(en => !en.result)) {
                              return false;
                           }
                           for (const schalt of schaltet) {
                              this.navElementContainer.removeEdgeWithID(schalt);
                           }
                           return true;
                        })
                        .catch((err) => false);
                     if (!response) {
                        this._messageSnackService.showSnackSuccess(
                           'Schaltet-Beziehungen konnten nicht entfernt werden.',
                           'NavElemListViewComponent',
                        );
                        return;
                     }
                  }
               }

               // -->>ASY
               this._navigationService.removeEdge(
                  __edge._id
               )
                  .then((boolResultASY: IBoolResult) => {

                     // result available
                     if (boolResultASY.result) {

                        // remove locally
                        this.navElementContainer.removeEdgeWithID(__edge._id);

                        // reaload
                        this.reloadContent();

                        this._loadingPhase = false;

                        // success
                        this._messageSnackService.showSnackSuccess('Beziehung gelöscht', 'NavElemListViewComponent');

                        // ok
                        return;
                     }

                     this._loadingPhase = false;

                     // no data
                     this._messageSnackService.showSnackWarning(boolResultASY.message.message, 'NavElemListViewComponent');
                  })
                  .catch((err: ErrorMessage) => {
                     this._loadingPhase = false;
                     this._messageSnackService.showSnackError(err.message, 'NavElemListViewComponent');
                  });

            }

            this._loadingPhase = false;
         });
   }

   private prepareAddEdgeLevel1(event, node) {
      try {
         // sanity I
         if (!this.navSearchMdlg) {
            console.warn('Missing navigation modal dialog object');
            return;
         }

         // sanity II
         if (!node.data.type || node.data.type !== NavListNodeType_edgeLevel1) {
            console.warn('Unexpected data type; expecting edgeLevel1');
            return;
         }

         // sanity III
         const rootNode: INavElementsNode = this.navElementContainer.getVirtualRoot().rootObj;
         if (!rootNode) {
            console.warn('Root Node nicht vorhanden');
            return;
         }

         // prüfe auf edgeDefinition in config
         const config: INavConfig = this._store.getState().navigationState.config;
         if (!config.hasOwnProperty('edgeDefinitions')) {
            console.warn('edgeDefinitions in config nicht vorhanden');
            return;
         }

         // Auszug aus config: edgeDefinition
         let edgeDefinition = config.edgeDefinitions[rootNode.group];
         if (!edgeDefinition) {
            // change search if root node
            edgeDefinition = config.edgeDefinitions[rootNode.id.split('/')[0]];
            if (!edgeDefinition) {
               console.warn('EdgeDefinition: "' + rootNode.group + '" nicht vorhanden');
               return;
            }
         }

         // Auszug aus config: Dictionary
         let dictItem = _.find(config.dictionary, item => item.key === rootNode.group);
         if (!dictItem) {
            // change search if root
            dictItem = _.find(config.dictionary, item => item.key === rootNode.id.split('/')[0]);
            if (!dictItem) {
               console.warn('Dictionary zur: ' + rootNode.id + ' nicht vorhanden');
               return;
            }
         }

         // concat ui text
         this.titelSearchGraph =
            this._titleSearchGraph + ' [' + dictItem.short + '] ' +
            this.navElementContainer.getVirtualRoot().rootObj.label;
         this.subtitleSearchGraph = this._subtitleSearchGraph + ' ' + (node.data.edgeGroupUi || node.data.edgeGroup);

         // store
         this._store.dispatch(navigationStore2stEdgeDefinitionConfig(
            {
               rootNode: rootNode,
               treeNodeDataEdgeGroup: node.data,
               edgeDefinitionConfig: edgeDefinition
            }
         ));

         // open dialog
         this.navSearchMdlg.openDialog();

      } catch (err) {
         console.warn('Fehler während Aufruf von Verknüpfungs-Dialog');
      }
   }

   private removeEdgeSchaltet(edgeID: string) {

      // ermittle zu löschende Edge
      if (!edgeID) {
         console.warn('Edge in Container nicht vorhanden');
         return;
      }

      this._loadingPhase = true;

      // -->>ASY
      this._navigationService.removeEdge(
         edgeID
      )
         .then((boolResultASY: IBoolResult) => {

            // result available
            if (boolResultASY.result) {

               // remove locally
               this.navElementContainer.removeEdgeWithID(edgeID);

               this._loadingPhase = false;

               // success
               this._messageSnackService.showSnackSuccess('Schaltzustand gespeichert', 'NavElemListViewComponent');

               // ok
               return;
            }

            this._loadingPhase = false;

            // no data
            this._messageSnackService.showSnackWarning(boolResultASY.message.message, 'NavElemListViewComponent');
         })
         .catch((err: ErrorMessage) => {
            this._loadingPhase = false;
            this._messageSnackService.showSnackError(err.message, 'NavElemListViewComponent');
         });
   }

   private addEdgeSchaltet(value, nodeID, edgeGroup?) {

      // sanity I
      const rootNode: INavElementsNode = this.navElementContainer.getVirtualRoot().rootObj;
      if (!rootNode) {
         console.warn('Root Node nicht vorhanden');
         return;
      }

      // erzeuge Edge object
      const edge: INavElementsEdge = {
         key: '',                  // erzeugt Backend
         rev: '',                  // erzeugt Backend
         id: '',                  // erzeugt Backend
         from: rootNode.id,
         to: nodeID,
         group: edgeGroup ? edgeGroup : 'Schaltet',
         label: '',                  // nicht gebraucht
         aktion: value
      };

      this._loadingPhase = true;

      // -->>ASYNC
      return this._navigationService.addEdgeWithAktion(
         edge
      )
         .then((data: INavElementsEdge) => {
            // result available
            if (data) {

               const node = this._treeData.getNodeById(data.to);

               this.navElementContainer.addNodeToGraph(node, this._config);

               // add edge locally
               this.navElementContainer.addEdge(
                  data
               );

               this._loadingPhase = false;

               // success
               this._messageSnackService.showSnackSuccess('Schaltzustand gespeichert', 'NavElemListViewComponent');

               // ok
               return data.id;
            }

            this._loadingPhase = false;

            // no data
            this._messageSnackService.showSnackWarning('Keine Daten vom Backend erhalten', 'NavElemListViewComponent');
            return null;
         })
         .catch((err: ErrorMessage) => {
            this._loadingPhase = false;
            this._messageSnackService.showSnackError(err.message, 'NavElemListViewComponent');
            return null;
         });
   }

   private updateEdgeSchaltet(value, edgeID, edgeGroup?) {

      // ermittle zu löschende Edge
      const _edge = this._treeData.getEdgeById(edgeID);
      if (!_edge) {
         console.warn('Edge in Container nicht vorhanden');
         return;
      }

      this._loadingPhase = true;

      // -->>ASYNC
      this._navigationService.saveEdge(
         {
            key: _edge._key,
            rev: _edge._rev,
            id: _edge._id,
            from: _edge._from,
            to: _edge._to,
            group: edgeGroup ? edgeGroup : 'Schaltet',
            label: '',                  // nicht gebraucht
            aktion: value
         }
      )
         .then((resultEdge: any) => {
            this._loadingPhase = false;

            // result available
            if (resultEdge) {

               // success
               this._messageSnackService.showSnackSuccess('Schaltzustand gespeichert', 'NavElemListViewComponent');

               this._treeData.updateEdge(resultEdge);
               // ok
               return;
            }

            // no data
            this._messageSnackService.showSnackWarning('Fehler beim Speichern des Schaltzustandes', 'NavElemListViewComponent');
         })
         .catch((err: ErrorMessage) => {
            this._loadingPhase = false;
            this._messageSnackService.showSnackError(err.message, 'NavElemListViewComponent');
         });
   }

   public setReadonly(hasRole: boolean) {
      this.readonly = !hasRole;
   }

   public isActiveDefaultsButton(modeGroup: string): boolean {
      if (this.readonly) {
         return false;
      }
      if (modeGroup) {
         return modeGroup === 'Steuerung' || modeGroup === 'Funktionsgruppe';
      }
      return false;
   }

   public onDefaultClick(nodeData: ITreeNode) {
      this._loadingPhase = true;
      this._confirmDialogService.open('Zurücksetzen',
         'Sind Sie sich sicher, dass sie alle Komponenten auf den Standard-Schaltet-Wert zurücksetzen möchten?',
         true, 'Nein', 'Ja').subscribe(
            (res) => {
               if (res) {
                  this._navigationService.setDefaults(nodeData._id).then((res) => {
                     const deleted = this._treeData.clearSchaltet(nodeData._id);
                     for (const edge of deleted) {
                        this.navElementContainer.removeEdgeWithID(edge);
                     }
                     for (const edge of res.edges || []) {
                        this._treeData.addEdge(edge);
                        this.navElementContainer.addEdge({
                           from: edge._from,
                           group: 'Schaltet',
                           id: edge._id,
                           key: edge._key,
                           label: '',
                           rev: edge._rev,
                           to: edge._to,
                           aktion: edge.aktion
                        });
                     }
                     this._messageSnackService.showSnackSuccess('Schaltungen zurückgesetzt', 'NavElemListViewComponent');
                     this.reloadContent();
                     this._loadingPhase = false;
                  });
               } else {
                  this._loadingPhase = false;
               }
            }
         );
   }
}


// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/compv/nav-tree/nav-tree.ts